import { render, staticRenderFns } from "./footerPrint.vue?vue&type=template&id=d82d0ed6&"
import script from "./footerPrint.vue?vue&type=script&lang=js&"
export * from "./footerPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports